import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

// export default function ProtectedRoute({ children }) {
//   const { isAuthenticated } = useSelector((state) => state.signup);

//   if (!isAuthenticated) {
//     return <Navigate to="/home" replace />;
//   }

//   return children;
// }

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, user } = useSelector((state) => state.signup);

  const verificationPending =
    user && (user.email_verified === false || user.mobile_verified === false);

  // if (verificationPending) {
  //   return <Navigate to="/otp" replace />;
  // }

  if (!isAuthenticated || verificationPending) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
